const PRIORITY = [
  {
    value: 1,
    render: (
      <div className="h-6 w-6 content-center bg-feedback-error-10 text-center text-tiny">1</div>
    ),
  },
  {
    value: 2,
    render: (
      <div className="h-6 w-6 content-center bg-feedback-success-10 text-center text-tiny">2</div>
    ),
  },
  {
    value: 3,
    render: (
      <div className="h-6 w-6 content-center bg-feedback-warning-10 text-center text-tiny">3</div>
    ),
  },
  {
    value: 4,
    render: (
      <div className="h-6 w-6 content-center bg-feedback-info-10 text-center text-tiny">4</div>
    ),
  },
  {
    value: 5,
    render: (
      <div className="h-6 w-6 content-center bg-accent-static-medium-light text-center text-tiny">
        5
      </div>
    ),
  },
];

export { PRIORITY };
